import DiscountValue from "@/modules/marketing/DiscountValue";
export default function DiscountAmount(){return <DiscountValue/>;}
